import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const TITLES: Record<string, string> = {
  '/dashboard': '仪表板',
  '/live': '资金账户大屏',
  '/employees': '注册用户管理',
  '/signals': '跟单审计',
  '/orders': '真实成交明细',
  '/user-orders': '用户订单',
  '/symbols': '品种与参数',
  '/session': '交易时段配置',
  '/trading-groups': '交易时段组',
  '/risk': '风控规则',
  '/assessment': '考核记录',
  '/assessment-config': '考核设置',
  '/ctids': 'cTID 与连接',
  '/audit-log': '审计日志',
  '/alerts': '告警中心',
  '/reports': '报表中心',
  '/platform-pnl': '平台经营',
  '/profit-share': '月度分润',
  '/invite-codes': '邀请码管理',
  '/app-version': 'App 版本管理',
  '/settings': '系统设置',
  '/login': '登录',
};

const BASE = 'cTrader 反向跟单系统 · Web 管理端';

/** 根据 URL 自动设置 document.title。挂在 AppLayout 根。 */
export function RouteTitle() {
  const { pathname } = useLocation();
  useEffect(() => {
    const seg = pathname.split('/').slice(0, 2).join('/');
    const title = TITLES[seg];
    document.title = title ? `${title} · ${BASE}` : BASE;
  }, [pathname]);
  return null;
}
